// Order Now button. IMPORTANT: does NOT rely on form="..." attribute cross-referencing, because
// Shopify silently disables that kind of attribute (renames it to data-sanitized-*) on content
// saved inside custom_liquid blocks, for security reasons. Everything here is found by CSS class
// or by Craft's own native data-type attribute instead, which are not affected.
(function () {
  function findAddToCartForm() {
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  function findEmptyRequiredField() {
    var fields = document.querySelectorAll('.cc-personalize-input[required]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var isEmpty = f.type === 'file' ? f.files.length === 0 : !f.value.trim();
      if (isEmpty) return f;
    }
    return null;
  }

  function showWarning(field) {
    field.classList.add('cc-field-error');
    field.focus();
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var block = field.closest('.cc-personalize-block');
    if (!block) return;
    var msg = block.querySelector('.cc-field-warning');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'cc-field-warning';
      msg.textContent = 'Please fill this in before you can place your order.';
      block.appendChild(msg);
    }
    msg.style.display = 'block';

    var clearWarning = function () {
      msg.style.display = 'none';
      field.classList.remove('cc-field-error');
      field.removeEventListener('input', clearWarning);
      field.removeEventListener('change', clearWarning);
    };
    field.addEventListener('input', clearWarning);
    field.addEventListener('change', clearWarning);
  }

  // Guards Craft's native Add to Cart button too, since its form has novalidate set.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var emptyField = findEmptyRequiredField();
      if (emptyField) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showWarning(emptyField);
      }
    },
    true
  );

  // Handles the custom Order Now button (plain type="button", no form attribute dependency).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cc-btn-primary');
    if (!btn) return;
    e.preventDefault();

    var emptyField = findEmptyRequiredField();
    if (emptyField) { showWarning(emptyField); return; }

    var form = findAddToCartForm();
    if (!form) { console.error('Classic Collection: add-to-cart form not found'); return; }

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput) { console.error('Classic Collection: variant id input not found'); return; }

    var qtyInput = document.querySelector('.quantity__input');
    var quantity = qtyInput ? qtyInput.value : 1;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Processing...';

    var formData = new FormData();
    formData.append('id', variantInput.value);
    formData.append('quantity', quantity);
    document.querySelectorAll('.cc-personalize-input').forEach(function (el) {
      if (!el.name) return;
      if (el.type === 'file') {
        if (el.files.length > 0) formData.append(el.name, el.files[0]);
      } else {
        formData.append(el.name, el.value);
      }
    });

    var cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    fetch(cartAddUrl, { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          console.error('Classic Collection: add to cart failed', data);
          btn.disabled = false;
          btn.textContent = originalText;
          alert(data.description || 'Something went wrong adding this to your cart. Please try again.');
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Classic Collection: add to cart request failed', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });
})();
